import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { FlaskService } from 'src/app/flask.service';
import { JavaService } from 'src/app/java.service';

@Component({
    selector: 'app-confirm-pin',
    templateUrl: './confirm-pin.component.html',
    styleUrls: ['./confirm-pin.component.css']
})
export class ConfirmPinComponent implements OnInit {

    pin = '';

    constructor(
        private _java: JavaService,
        private _router: Router,
        private _route: ActivatedRoute,
        private _flask: FlaskService,
    ) {

    }

    ngOnInit() {
        this.getPin();
    }

    onBack() {
        this._java.javaConnector.goBack();
    }

    async onSubmit(pin: string) {
        if (pin === this.pin) {
            const jc = this._java.javaConnector;

            this._flask.setPin(pin);
            //            jc.setPIN(pin);
            jc.gotoTRAdmin();
        } else {
            this._router.navigate(['/tr/pin-mismatch']);
        }
    }

    private async getPin() {
        const { pin } = await firstValueFrom(this._route.queryParams);

        this.pin = pin;
    }
}
